import React, { useEffect, useState, useContext } from "react"
import { useForm } from "react-hook-form"
import Loader from "react-loader-spinner"
import ModalInfo from "../modal-info/modal-info"
import { Context } from "../../../context/app-context"
import {
  costActivity,
  competitionId
} from "../../../constants/activity-constants"

import sessionStorage from "./../../../utils/sessionStorage"
import gameServices from "../../../services/game-service"
import pointsServices from "../../../shared/services/my-points-service"
import useMediaQuery from "../../../utils/useMediaQuery"

import "./modal-redeem.scss"

export default function ModalRedeem(props) {
  const { handleSuccess } = props
  const { dispatch } = useContext(Context)
  const [session] = useState(new sessionStorage())
  const { register, handleSubmit, reset } = useForm()
  const [userData, setUserData] = useState({ name: "", userPoints: 0 })
  const [msgKeyError, setMsgKeyError] = useState(null)
  const [msgKeyNotPoints, setMsgKeyNotPoints] = useState(null)
  const [msgKeySuccess, setMsgKeySuccess] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const isMobile = useMediaQuery()

  const onSubmitKey = data => {
    if (isLoading) return
    setIsLoading(true)
    let payload = {
      key: { code: data.code.toUpperCase() },
      activity: competitionId.toString()
    }
    var config = {
      headers: {
        Authorization: session.getToken().idToken
      }
    }
    pointsServices
      .postMyKeys(payload,false, config)
      .then(res => {
        if (res.status === 200) {
          session.authUserInfo({
            handleSuccess: res => {
              setUserData(res.data)
            }
          })
          setMsgKeySuccess(res.userMessage)
          setTimeout(() => {
            setMsgKeySuccess(null)
          }, 2500)
        } else {
          setMsgKeyError(res.userMessage)
          setTimeout(() => {
            setMsgKeyError(null)
          }, 2500)
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setIsLoading(false)
        reset({})
      })
  }

  const handleRedimir = () => {
    if (isLoading) return
    setIsLoading(true)
    let points = userData.userPoints
    if (
      points.pointsAccumulation + points.pointsPresent + points.pointsToExpire <
      costActivity
    ) {
      setMsgKeyNotPoints("No tienes puntos suficientes para participar.")
      setTimeout(() => {
        setMsgKeyNotPoints(null)
      }, 4000)
      setIsLoading(false)
      return
    }

    var tokenId = session.getToken().idToken
    var config = {
      headers: {
        Authorization: tokenId
      }
    }
    gameServices.getTokenGame(competitionId, config).then(res => {
      if (res.status === 200) {
        dispatch({
          type: "set-context",
          payload: {
            tokenParticipation: res.data.tokenGame
          }
        })
        if (handleSuccess) handleSuccess()
      } else if (res.errorCode === "DEM061") {
        // "DEM061": Sin participacion pendiente
        gameServices
          .postGameParticipationRedeem(competitionId, config)
          .then(res => {
            if (res.status === 200) {
              // si tiene un token activo Mostrar mensaje y redireccionar
              dispatch({
                type: "set-context",
                payload: {
                  tokenParticipation: res.data.tokenGame
                }
              })
              if (handleSuccess) handleSuccess()
            } else {
              setMsgKeyNotPoints(res.userMessage)
              setTimeout(() => {
                setMsgKeyNotPoints(null)
                setIsLoading(false)
              }, 2500)
            }
          })
      } else {
        // Example: "UEM026"= el concurso ya finalizo
        setMsgKeyNotPoints(res.userMessage)
        setTimeout(() => {
          setMsgKeyNotPoints(null)
          setIsLoading(false)
        }, 4000)
      }
    })
  }

  useEffect(() => {
    session.authUserInfo({
      handleSuccess: res => {
        setUserData(res.data)
      }
    })
  }, [session])

  return (
    <>
      {(msgKeyError && (
        <ModalInfo
          {...{
            title: "¡Uuuups!",
            body: (
              <>
                <p className="family-Bw-Black color-blue size-18">
                  La clave que ingresaste no es correcta,
                </p>
                <p className="family-Bw-Black color-blue size-18">
                  ¡Vuelve a intentarlo!
                </p>
                <p className="family-Bw-Black color-blue size-14">
                  Recuerda ingresarla
                  <span className="bold"> sin guiones ni espacios.</span>
                </p>
              </>
            )
          }}
        />
      )) || (
        <div className="modal-redeem">
          <div className="modal-redeem-container">
            <div className="wrapper-star">
              <span className="family-TrashHand size-35 color-blue">
                {userData.name}
              </span>
              <p className="size-27 paragraph--1">
                <span className=" family-Bw-Black color-blue size-18">
                  Tienes{" "}
                </span>
                <span className="family-Bw-Black color-pink-heavy size-20">
                  {userData?.userPoints &&
                    (
                      userData.userPoints.pointsAccumulation +
                      userData.userPoints.pointsPresent +
                      userData.userPoints.pointsToExpire
                    ).toLocaleString()}{" "}
                  PUNTOS
                </span>
                <br />
                {/* <span className="family-Bw-Black color-aqua">PUNTOS</span>
                <br /> */}
              </p>
              <p className="family-H-Bold size-14 color-blue">
                acumulados en NosotrasOnline.
              </p>
              <p className="family-H-Bold size-14 color-blue paragraph--2">
                ¿Estás segura de que quieres <br />
                <span className="family-H-Bold color-pink-heavy">
                  canjear {costActivity} puntos
                </span>{" "}
                para jugar?
              </p>
              <p className="family-H-Bold size-15 color-blue paragraph--3">
                1 oportunidad = {costActivity} puntos
              </p>
              {msgKeyNotPoints && (
                <p className="key-error-message">*{msgKeyNotPoints}</p>
              )}
              {(isLoading && (
                <Loader
                  type="TailSpin"
                  color="#ffffff"
                  height={30}
                  width={30}
                />
              )) || (
                <button
                  className="f-btn-submit-redention btn-secondary--2 size-11"
                  onClick={handleRedimir}
                >
                  QUIERO CANJEAR Y JUGAR
                </button>
              )}
                          <form onSubmit={handleSubmit(onSubmitKey)}>
              <div className="modal-redeem-input-container">
                <label htmlFor="code" className="size-14">
                  <span className="bold">¿No tienes puntos?</span> <br />
                  Inscribe aquí las claves de tus productos <br />
                  Nosotras y acumula puntos para jugar.
                </label>
                <input
                  className="f-input-redention"
                  maxLength={10}
                  ref={register({
                    required: true
                  })}
                  placeholder="- - - - - - "
                  name="code"
                />
                {msgKeySuccess && (
                  <p className="key-success-message">*{msgKeySuccess}</p>
                )}
              </div>
              {(isLoading && (
                <Loader
                  type="TailSpin"
                  color="#ffffff"
                  height={30}
                  width={30}
                />
              )) || (
                <button className="f-btn-submit-key btn-primary size-11" type="submit">
                  ENVIAR
                </button>
              )}
            </form>
            </div>

          </div>
        </div>
      )}
    </>
  )
}
